import { render, staticRenderFns } from "./WarrantyRequest.vue?vue&type=template&id=682961da&scoped=true&"
import script from "./WarrantyRequest.vue?vue&type=script&lang=js&"
export * from "./WarrantyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682961da",
  null
  
)

export default component.exports